var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 14.58C9.86008 14.58 7.71008 12.43 7.71008 9.79C7.71008 7.15 9.86008 5 12.5001 5C15.1401 5 17.2901 7.15 17.2901 9.79C17.2901 12.43 15.1401 14.58 12.5001 14.58ZM12.5001 6.365C10.6151 6.365 9.08008 7.9 9.08008 9.785C9.08008 11.67 10.6151 13.205 12.5001 13.205C14.3851 13.205 15.9201 11.67 15.9201 9.785C15.9201 7.9 14.3851 6.365 12.5001 6.365Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.345 20.055H17.975C17.975 17.035 15.52 14.58 12.5 14.58C9.48003 14.58 7.02503 17.035 7.02503 20.055H5.65503C5.65503 16.28 8.72503 13.21 12.5 13.21C16.275 13.21 19.345 16.28 19.345 20.055Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_315)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -2,
    width: 32,
    height: 34,
    fill: "#B1AEAE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.2d85e9579407bd5841ee0e83f9ce636e.svg";
export { ForwardRef as ReactComponent };